import React, { useEffect, useState, useCallback } from "react";
import { connect } from 'react-redux';
import { AsyncPaginate } from "react-select-async-paginate";
import Select from 'react-select';

import { search, searchFocusedToggle } from '../../../../actions';
import { getSpecializations } from '../../../../actions/doctors';
import * as api from '../../../../api';
import { useUrlParser } from '../../../../utils/useUrlParser';
import { isMobile } from '../../../../utils/mobile';
import { useHistory } from "react-router-dom";
import { set } from "date-fns";
import doctor from "../../../../reducers/Doctors/doctor";

const urlParser = useUrlParser();

const SearchForm = ({ getDoctorsJobs, searchFilters, setSearchFilters }) => {
  // Existing state variables
  const [valueInstitution, setValueInstitution] = useState(null);
  const [valueSpecialization, setValueSpecialization] = useState(null);
  const [valueDoctor, setValueDoctor] = useState(null);
  const [visitDate, setVisitDate] = useState("");
  const [valueRank, setValueRank] = useState(null);

  // New state variables for additional filters
  const [valueRegion, setValueRegion] = useState(null);
  const [valueCity, setValueCity] = useState(null);
  const [valueServiceType, setValueServiceType] = useState({ 
    value: 'consultation', 
    label: 'Консультація лікаря / Лабораторне/інструментальне дослідження' 
  });
  // New state variable for medical service
  const [valueMedicalService, setValueMedicalService] = useState(null);
  const [medicalServiceSearchQuery, setMedicalServiceSearchQuery] = useState("");
  
  // Add state for validation and tooltip
  const [showTooltip, setShowTooltip] = useState(false);

  const [selecteOpened, setSelecteOpened] = useState(false);

  const [institutionSearchQuery, setInstitutionSearchQuery] = useState("");
  const [specializationSearchQuery, setSpecializationSearchQuery] = useState("");
  const [doctorSearchQuery, setDoctorSearchQuery] = useState("");
  const [regionSearchQuery, setRegionSearchQuery] = useState("");
  const [citySearchQuery, setCitySearchQuery] = useState("");
  const [rankSearchQuery, setRankSearchQuery] = useState("");

  // Mobile modal states
  const [showMobileModal, setShowMobileModal] = useState(null);
  const [mobileOptions, setMobileOptions] = useState([]);
  const [mobileLoading, setMobileLoading] = useState(false);
  const [mobileSearchQuery, setMobileSearchQuery] = useState('');
  const [mobilePage, setMobilePage] = useState(1);
  const [mobileHasMore, setMobileHasMore] = useState(true);

  const history = useHistory();

  // Service type options
  const serviceTypeOptions = [
    { value: 'consultation', label: 'Консультація лікаря / Лабораторне/інструментальне дослідження' }
  ];

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const getMaxDate = () => {
    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 28);
    const year = maxDate.getFullYear();
    const month = String(maxDate.getMonth() + 1).padStart(2, '0');
    const day = String(maxDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    if(!searchFilters?.region_id) {
      loadInitialLocation();
    }
  }, []);
  
  // Load initial location data when component mounts
  const loadInitialLocation = async () => {
    try {
      // Check if we already have location in searchFilters
      if (searchFilters?.region_id || searchFilters?.city_id) {
        return; // Skip if location already specified in filters
      }
      
      const location = await api.getInitialCity();
      if (location && location.data) {          
        // Set city ID if available
        if (location.data.id) {
          try {
            // First set the values
            const regionData = location.data.region;
            const cityData = location.data;
            
            setValueRegion(regionData);
            setValueCity(cityData);

          } catch (err) {
            console.error('Failed to load city:', err);
          }
        }
      }
    } catch (error) {
      console.error('Failed to load initial location:', error);
    }
  };
  
  // Load options for regions
  const loadOptionsRegions = async (searchQuery, loadedOptions, { page }) => {
    const query = `?name=${searchQuery}&page=${page}&paid_service=true`;
    const responseJSON = await api.getRegions(query);

    return {
      options: responseJSON.data,
      hasMore: responseJSON.pagination.current_page < responseJSON.pagination.total_pages,
      additional: {
        page: page+1,
      },
    };
  };

  // Load options for cities based on selected region
  const loadOptionsCities = async (searchQuery, loadedOptions, { page }) => {
    const regionId = valueRegion?.id || '';
    const query = `?name=${searchQuery}&region_id=${regionId}&page=${page}&paid_service=true`;
    const responseJSON = await api.getCities(query);

    return {
      options: responseJSON.data,
      hasMore: responseJSON.pagination.current_page < responseJSON.pagination.total_pages,
      additional: {
        page: page+1,
      },
    };
  };

  const loadOptionsInstitution = async (searchQuery, loadedOptions, { page }) => {
    const regionId = valueRegion?.id || '';
    const cityId = valueCity?.id || '';
    const query = `?name=${searchQuery}&region_id=${regionId}&city_id=${cityId}&page=${page}&paid_service=true`;
    const responseJSON = await api.getHospitals(query);

    return {
      options: responseJSON.data,
      hasMore: responseJSON.pagination.current_page < responseJSON.pagination.total_pages,
      additional: {
        page: page+1,
      },
    };
  };

  const loadOptionsSpecializations = async (searchQuery, loadedOptions, { page }) => {
    const regionId = valueRegion?.id || '';
    const cityId = valueCity?.id || '';
    const institutionId = valueInstitution?.id || '';
    const query = `?name=${searchQuery}&region_id=${regionId}&city_id=${cityId}&has_doctors=1&institution_id=${institutionId}&rank_id=${valueRank?.id || ''}&page=${page}&paid_service=true`;
    const responseJSON = await api.getSpecializations(query);

    return {
      options: responseJSON.data,
      hasMore: responseJSON.pagination.current_page < responseJSON.pagination.total_pages,
      additional: {
        page: page+1,
      },
    };
  };
  const loadOptionsRanks = async (searchQuery, loadedOptions, { page }) => {
    const regionId = valueRegion?.id || '';
    const cityId = valueCity?.id || '';
    const institutionId = valueInstitution?.id || '';
    const query = `?name=${searchQuery}&region_id=${regionId}&city_id=${cityId}&has_doctors=1&institution_id=${institutionId}&page=${page}&paid_service=true`;
    const responseJSON = await api.getRanks(query);

    return {
      options: responseJSON.data,
      hasMore: responseJSON.pagination.current_page < responseJSON.pagination.total_pages,
      additional: {
        page: page+1,
      },
    };
  };

  const loadOptionsDoctors = async (searchQuery, loadedOptions, { page }) => {
    const regionId = valueRegion?.id || '';
    const cityId = valueCity?.id || '';
    const specializationId = valueSpecialization?.id || '';
    const institutionId = valueInstitution?.id || '';

    const query = `?name=${searchQuery}&region_id=${regionId}&city_id=${cityId}&institution_id=${institutionId}&specialization_id=${specializationId}&rank_id=${valueRank?.id || ''}&page=${page}&paid_service=true`;
    const responseJSON = await api.searchDoctors(query);

    return {
      options: responseJSON.data,
      hasMore: responseJSON.pagination.current_page < responseJSON.pagination.total_pages,
      additional: {
        page: page+1,
      },
    };
  };

  // Load options for medical services
  const loadOptionsMedicalServices = async (searchQuery, loadedOptions, { page }) => {
    const regionId = valueRegion?.id || '';
    const cityId = valueCity?.id || '';
    const institutionId = valueInstitution?.id || '';
    const query = `?title=${searchQuery}&region_id=${regionId}&city_id=${cityId}&institution_id=${institutionId}&specialization_id=${valueSpecialization?.id || ''}&doctor_id=${valueDoctor?.id || ''}&rank_id=${valueRank?.id || ''}&page=${page}&paid_service=true`;
    const responseJSON = await api.getMedicalServices(query);

    return {
      options: responseJSON.data,
      hasMore: responseJSON.pagination.current_page < responseJSON.pagination.total_pages,
      additional: {
        page: page+1,
      },
    };
  };

  const onChangeInstitution = (option) => {
    setValueInstitution(option);
    if(option !== null) {
      setValueSpecialization("");
      setValueDoctor("");
    } else {
      sessionStorage.removeItem('institutionSearchQuery');
    }
  };
  
  const onChangeSpecialization = (option) => {
    setValueSpecialization(option);
    if(option !== null) {
      setValueDoctor("");
    } else {
      sessionStorage.removeItem('specializationSearchQuery');
    }
  };
  const onChangeRank = (option) => {
    setValueRank(option);
    if(option !== null) {
      setValueDoctor("");
    } else {
      sessionStorage.removeItem('rankSearchQuery');
    }
  };
  const onChangeDoctor = (option) => {
    setValueDoctor(option);
    if(option === null) {
      sessionStorage.removeItem('doctorSearchQuery');
    }
  };

  // Event handlers for new select fields
  const onChangeRegion = (option) => {
    setValueRegion(option);
    if(option !== null) {
      setValueCity(null);
      setValueInstitution(null);
      setValueSpecialization(null);
      setValueDoctor(null);
    }
  };
  
  const onChangeCity = (option) => {
    setValueCity(option);
    if(option !== null) {
      setValueInstitution(null);
      setValueSpecialization(null);
      setValueDoctor(null);
    }
  };
  
  const onChangeServiceType = (option) => {
    setValueServiceType(option);
  };

  // Event handler for medical service select
  const onChangeMedicalService = (option) => {
    setValueMedicalService(option);
  };

  // Menu handlers for region select
  const onRegionMenuOpen = () => {
    setSelecteOpened(true);
    const savedQuery = sessionStorage.getItem('regionSearchQuery') || '';
    if (savedQuery && regionSearchQuery === '') {
      setRegionSearchQuery(savedQuery);
    }
  };

  const onRegionMenuClose = () => {
    if(selecteOpened) {
      sessionStorage.setItem('regionSearchQuery', regionSearchQuery);
      setSelecteOpened(false);
    }
  };

  // Menu handlers for city select
  const onCityMenuOpen = () => {
    setSelecteOpened(true);
    const savedQuery = sessionStorage.getItem('citySearchQuery') || '';
    if (savedQuery && citySearchQuery === '') {
      setCitySearchQuery(savedQuery);
    }
  };

  const onCityMenuClose = () => {
    if(selecteOpened) {
      sessionStorage.setItem('citySearchQuery', citySearchQuery);
      setSelecteOpened(false);
    }
  };

  const onInstitutionMenuOpen = () => {
      setSelecteOpened(true);
      const savedQuery = sessionStorage.getItem('institutionSearchQuery') || '';
      if (savedQuery && institutionSearchQuery === '') {
        setInstitutionSearchQuery(savedQuery);
      }
  };

  const onInstitutionMenuClose = () => {
    if(selecteOpened) {
      sessionStorage.setItem('institutionSearchQuery', institutionSearchQuery);
      setSelecteOpened(false);
    }
  };

  const onSpecializationMenuOpen = () => {
    setSelecteOpened(true);
    const savedQuery = sessionStorage.getItem('specializationSearchQuery') || '';
    if (savedQuery && specializationSearchQuery === '') {
      setSpecializationSearchQuery(savedQuery);
    }
  };

  const onSpecializationMenuClose = () => {
    if(selecteOpened) {
      sessionStorage.setItem('specializationSearchQuery', specializationSearchQuery);
      setSelecteOpened(false);
    }
  };

  const onRankMenuOpen = () => {
    setSelecteOpened(true);
    const savedQuery = sessionStorage.getItem('rankSearchQuery') || '';
    if (savedQuery && rankSearchQuery === '') {
      setRankSearchQuery(savedQuery);
    }
  };

  const onRankMenuClose = () => {
    if(selecteOpened) {
      sessionStorage.setItem('rankSearchQuery', rankSearchQuery);
      setSelecteOpened(false);
    }
  };

  const onDoctorMenuOpen = () => {
    setSelecteOpened(true);
    const savedQuery = sessionStorage.getItem('doctorSearchQuery') || '';
    if (savedQuery && doctorSearchQuery === '') {
      setDoctorSearchQuery(savedQuery);
    }
  };

  const onDoctorMenuClose = () => {
    if(selecteOpened) {
      sessionStorage.setItem('doctorSearchQuery', doctorSearchQuery);
      setSelecteOpened(false);
    }
  };

  // Menu handlers for medical service select
  const onMedicalServiceMenuOpen = () => {
    setSelecteOpened(true);
    const savedQuery = sessionStorage.getItem('medicalServiceSearchQuery') || '';
    if (savedQuery && medicalServiceSearchQuery === '') {
      setMedicalServiceSearchQuery(savedQuery);
    }
  };

  const onMedicalServiceMenuClose = () => {
    if(selecteOpened) {
      sessionStorage.setItem('medicalServiceSearchQuery', medicalServiceSearchQuery);
      setSelecteOpened(false);
    }
  };

  const handleFilterChange = (event) => {
    // Missing implementation and closing bracket here
  }; // Added the missing closing bracket and semicolon

  // Mobile modal functions
  const openMobileModal = (type) => {
    setShowMobileModal(type);
    setMobileOptions([]);
    setMobileSearchQuery('');
    setMobilePage(1);
    setMobileHasMore(true);
    loadMobileOptions(type, '', 1);
  };

  const closeMobileModal = () => {
    setShowMobileModal(null);
    setMobileOptions([]);
    setMobileSearchQuery('');
  };

  const loadMobileOptions = async (type, searchQuery = '', page = 1) => {
    if (page === 1) {
      setMobileLoading(true);
    }

    try {
      let responseJSON;
      
      switch (type) {
        case 'region':
          const regionQuery = `?name=${searchQuery}&page=${page}&paid_service=true`;
          responseJSON = await api.getRegions(regionQuery);
          break;
        case 'city':
          const regionId = valueRegion?.id || '';
          const cityQuery = `?name=${searchQuery}&region_id=${regionId}&page=${page}&paid_service=true`;
          responseJSON = await api.getCities(cityQuery);
          break;
        case 'institution':
          const cityId = valueCity?.id || '';
          const regionForInstitution = valueRegion?.id || '';
          const institutionQuery = `?name=${searchQuery}&city_id=${cityId}&region_id=${regionForInstitution}&page=${page}&paid_service=true`;
          responseJSON = await api.getHospitals(institutionQuery);
          break;
        case 'specialization':
          const instId = valueInstitution?.id || '';
          const cityIdForSpec = valueCity?.id || '';
          const regionIdForSpec = valueRegion?.id || '';
          const specializationQuery = `?name=${searchQuery}&institution_id=${instId}&city_id=${cityIdForSpec}&region_id=${regionIdForSpec}&has_doctors=1&page=${page}&paid_service=true`;
          responseJSON = await api.getSpecializations(specializationQuery);
          break;
        case 'rank':
          const rankQuery = `?name=${searchQuery}&page=${page}&paid_service=true`;
          responseJSON = await api.getRanks(rankQuery);
          break;
        case 'doctor':
          const specId = valueSpecialization?.id || '';
          const institutionIdForDoctor = valueInstitution?.id || '';
          const cityIdForDoctor = valueCity?.id || '';
          const regionIdForDoctor = valueRegion?.id || '';
          const rankId = valueRank?.id || '';
          const doctorQuery = `?name=${searchQuery}&specialization_id=${specId}&institution_id=${institutionIdForDoctor}&city_id=${cityIdForDoctor}&region_id=${regionIdForDoctor}&rank_id=${rankId}&page=${page}&paid_service=true`;
          responseJSON = await api.searchDoctors(doctorQuery);
          break;
        case 'medicalService':
          const serviceQuery = `?name=${searchQuery}&page=${page}&paid_service=true`;
          responseJSON = await api.getMedicalServices(serviceQuery);
          break;
        default:
          return;
      }

      if (page === 1) {
        setMobileOptions(responseJSON.data);
      } else {
        setMobileOptions(prev => [...prev, ...responseJSON.data]);
      }
      
      setMobileHasMore(responseJSON.pagination.current_page < responseJSON.pagination.total_pages);
    } catch (error) {
      console.error('Error loading mobile options:', error);
    } finally {
      setMobileLoading(false);
    }
  };

  const handleMobileSearch = (query) => {
    setMobileSearchQuery(query);
    setMobilePage(1);
    loadMobileOptions(showMobileModal, query, 1);
  };

  const loadMoreMobileOptions = () => {
    if (mobileHasMore && !mobileLoading) {
      const nextPage = mobilePage + 1;
      setMobilePage(nextPage);
      loadMobileOptions(showMobileModal, mobileSearchQuery, nextPage);
    }
  };

  const selectMobileOption = (option) => {
    switch (showMobileModal) {
      case 'region':
        onChangeRegion(option);
        break;
      case 'city':
        onChangeCity(option);
        break;
      case 'institution':
        onChangeInstitution(option);
        break;
      case 'specialization':
        onChangeSpecialization(option);
        break;
      case 'rank':
        onChangeRank(option);
        break;
      case 'doctor':
        onChangeDoctor(option);
        break;
      case 'medicalService':
        onChangeMedicalService(option);
        break;
    }
    closeMobileModal();
  };

  const clearMobileValue = (type, event) => {
    event.stopPropagation();
    switch (type) {
      case 'region':
        onChangeRegion(null);
        break;
      case 'city':
        onChangeCity(null);
        break;
      case 'institution':
        onChangeInstitution(null);
        break;
      case 'specialization':
        onChangeSpecialization(null);
        break;
      case 'rank':
        onChangeRank(null);
        break;
      case 'doctor':
        onChangeDoctor(null);
        break;
      case 'medicalService':
        onChangeMedicalService(null);
        break;
    }
  };

  useEffect(() => {
    if(typeof setSearchFilters === 'function' ) {
      // handleSearch();
    }
  }, [visitDate, valueInstitution, valueSpecialization, valueDoctor]);

  // Update search parameters to include new filters
  const handleSearch = () => {
    // Check if medical service is selected
    if (!valueMedicalService) {
      setShowTooltip(true);
      // Hide tooltip after 3 seconds
      setTimeout(() => {
        setShowTooltip(false);
      }, 3000);
      return; // Prevent search if medical service is not selected
    }
    

    getDoctorsJobs({
      pageSize: 30,
      page: +urlParser.urlData.params.doctors_page > 0 && Number.isInteger(+urlParser.urlData.params.doctors_page) ? +urlParser.urlData.params.doctors_page : 1,

      regionId: valueRegion?.id || null,
      cityId: valueCity?.id || null,
      institutionId: valueInstitution?.id || null,
      specializationId: valueSpecialization?.id || null,
      doctorId: valueDoctor?.id || null,
      medicalServiceId: valueMedicalService?.id || null,
      paidService: true,
      rankId: valueRank?.id || null,
    });
    
    // Prepare search parameters
    const params = {
      region_id: valueRegion?.id || null,
      city_id: valueCity?.id || null,
      service_type: valueServiceType?.value || null,
      institution_id: valueInstitution?.id || null,
      specialization_id: valueSpecialization?.id || null,
      rank_id: valueRank?.id || null,
      doctor_id: valueDoctor?.id || null,
      visit_date: visitDate || null,
      medical_service_id: valueMedicalService?.id || null,
      medical_service: valueMedicalService || null,
    };

    // Update searchFilters first
    if(typeof setSearchFilters === 'function') {
      setSearchFilters(params);
    }
  };

  const loadInitialData = useCallback(async () => {
    if (searchFilters) {
      // Load region
      if (searchFilters.region_id) {
        try {
          const query = `?id=${searchFilters.region_id}`;
          const regions = await api.getRegions(query);
          if (regions && regions.data.length > 0) {
            setValueRegion(regions.data[0]);
          }
        } catch (err) {
          console.error('Failed to load region:', err);
        }
      }

      // Load city
      if (searchFilters.city_id) {
        try {
          const query = `?id=${searchFilters.city_id}`;
          const cities = await api.getCities(query);
          if (cities && cities.data.length > 0) {
            setValueCity(cities.data[0]);
          }
        } catch (err) {
          console.error('Failed to load city:', err);
        }
      }

      // Set service type
      if (searchFilters.service_type) {
        const selectedServiceType = serviceTypeOptions.find(option => option.value === searchFilters.service_type);
        if (selectedServiceType) {
          setValueServiceType(selectedServiceType);
        }
      }
      
      // Load institution
      if (searchFilters.institution_id) {
        try {
          const institution = await api.getHospital(searchFilters.institution_id);
          if (institution) setValueInstitution(institution.data);            
        } catch (err) {
          console.error('Failed to load institution:', err);
        }
      }

      // Load specialization
      if (searchFilters.specialization_id) {
        try {
          const query = `?id=${searchFilters.specialization_id}`;
          const specialization = await api.getSpecializations(query);
          if (specialization) setValueSpecialization(specialization.data[0]);
        } catch (err) {
          console.error('Failed to load specialization:', err);
        }
      }
      // Load rank
      if (searchFilters.rank_id) {
        try {
          const query = `?id=${searchFilters.rank_id}`;
          const rank = await api.getRanks(query);
          if (rank) setValueRank(rank.data[0]);
        } catch (err) {
          console.error('Failed to load rank:', err);
        }
      }

      // Load doctor
      if (searchFilters.doctor_id) {
        try {
          const doctor = await api.getDoctor(searchFilters.doctor_id);
          if (doctor) setValueDoctor(doctor.data);
        } catch (err) {
          console.error('Failed to load doctor:', err);
        }
      }

      // Load medical service
      if (searchFilters.medical_service_id) {
        try {
          const query = `?id=${searchFilters.medical_service_id}`;
          const medicalServices = await api.getMedicalServices(query);
          if (medicalServices && medicalServices.data.length > 0) {
            setValueMedicalService(medicalServices.data[0]);
            // setTimeout(() => {
            //   console.log('valueMedicalService:', valueMedicalService);
            //   handleSearch();
            // }, 200);
          }
        } catch (err) {
          console.error('Failed to load medical service:', err);
        }
      }

      // Set visit date
      if (searchFilters.visit_date) {
        setVisitDate(searchFilters.visit_date);
      }
    }    
  }, [searchFilters]);

  
  useEffect(() => {
    let hasChanges = false;
    
    // Check for changes in the new filters
    if (searchFilters?.region_id !== undefined && searchFilters?.region_id !== null && 
        parseInt(searchFilters?.region_id) !== parseInt(valueRegion?.id)) {
      setValueRegion(searchFilters.region_id);
      hasChanges = true;
    }
    
    if (searchFilters?.city_id !== undefined && searchFilters?.city_id !== null && 
        parseInt(searchFilters?.city_id) !== parseInt(valueCity?.id)) {
      setValueCity(searchFilters.city_id);
      hasChanges = true;
    }
    
    if (searchFilters?.service_type !== undefined && searchFilters?.service_type !== valueServiceType?.value) {
      const selectedServiceType = serviceTypeOptions.find(option => option.value === searchFilters.service_type);
      if (selectedServiceType) {
        setValueServiceType(selectedServiceType);
        hasChanges = true;
      }
    }
    
    if(searchFilters?.visit_date !== undefined) {
      setVisitDate(searchFilters.visit_date);
    }
    if(searchFilters?.institution_id !== undefined && searchFilters?.institution_id !== null && parseInt(searchFilters?.institution_id) !== parseInt(valueInstitution?.id)) {
      setValueInstitution(searchFilters.institution_id);
      hasChanges = true;
    }
    
    if(searchFilters?.specialization_id !== undefined && searchFilters?.specialization_id !== null && parseInt(searchFilters?.specialization_id) !== parseInt(valueSpecialization?.id)) {
      setValueSpecialization(searchFilters.specialization_id);
      hasChanges = true;
    }
    if(searchFilters?.rank_id !== undefined && searchFilters?.rank_id !== null && parseInt(searchFilters?.rank_id) !== parseInt(valueRank?.id)) {
      setValueRank(searchFilters.rank_id);
      hasChanges = true;
    }
    if(searchFilters?.doctor_id !== undefined && searchFilters?.doctor_id !== null && parseInt(searchFilters?.doctor_id) !== parseInt(valueDoctor?.id)) {
      setValueDoctor(searchFilters.doctor_id);
      hasChanges = true;
    }
    if(searchFilters?.medical_service_id !== undefined && searchFilters?.medical_service_id !== null && parseInt(searchFilters?.medical_service_id) !== parseInt(valueMedicalService?.id)) {
      setValueMedicalService(searchFilters.medical_service_id);
      hasChanges = true;
    }
    
    if(hasChanges) {
      loadInitialData();
    }
  }, [searchFilters]);

  return (
    <div className={`search-form ${isMobile() ? 'mobile' : ''}`}>
      {/* New row for region, city, and service type */}
      <div className="search-form__grid">
        <div className="search-form__section">
          <label className="form-label">Область</label>
          {isMobile() ? (
            <div 
              className="mobile-select-trigger"
              onClick={() => openMobileModal('region')}
            >
              <span className="mobile-select-text">
                {valueRegion ? valueRegion.name : 'Оберіть регіон'}
              </span>
              <div className="mobile-select-actions">
                {valueRegion && (
                  <button 
                    className="mobile-clear-button"
                    onClick={(e) => clearMobileValue('region', e)}
                    type="button"
                  >
                    <i className="fas fa-times"></i>
                  </button>
                )}
                <i className="fas fa-chevron-down mobile-dropdown-icon"></i>
              </div>
            </div>
          ) : (
            <AsyncPaginate
              key={JSON.stringify([])}
              value={valueRegion}
              inputValue={regionSearchQuery}
              onInputChange={setRegionSearchQuery}
              onMenuOpen={onRegionMenuOpen}
              onMenuClose={onRegionMenuClose}
              loadOptions={loadOptionsRegions}
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => option.name}
              onChange={onChangeRegion}
              loadingMessage={() => "Завантаження..."}
              noOptionsMessage={() => "Немає варіантів"}
              isSearchable={true}
              isClearable={true}
              placeholder="Оберіть регіон"
              additional={{
                page: 1,
              }}
            />
          )}
        </div>

        <div className="search-form__section">
          <label className="form-label">Населений пункт</label>
          {isMobile() ? (
            <div 
              className="mobile-select-trigger"
              onClick={() => openMobileModal('city')}
            >
              <span className="mobile-select-text">
                {valueCity ? valueCity.name : 'Оберіть місто'}
              </span>
              <div className="mobile-select-actions">
                {valueCity && (
                  <button 
                    className="mobile-clear-button"
                    onClick={(e) => clearMobileValue('city', e)}
                    type="button"
                  >
                    <i className="fas fa-times"></i>
                  </button>
                )}
                <i className="fas fa-chevron-down mobile-dropdown-icon"></i>
              </div>
            </div>
          ) : (
            <AsyncPaginate
              key={JSON.stringify([valueRegion])}
              value={valueCity}
              inputValue={citySearchQuery}
              onInputChange={setCitySearchQuery}
              onMenuOpen={onCityMenuOpen}
              onMenuClose={onCityMenuClose}
              loadOptions={loadOptionsCities}
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => option.name}
              onChange={onChangeCity}
              loadingMessage={() => "Завантаження..."}
              noOptionsMessage={() => "Немає варіантів"}
              isSearchable={true}
              isClearable={true}
              placeholder="Оберіть населений пункт"
              // isDisabled={!valueRegion}
              additional={{
                page: 1,
              }}
            />
          )}
        </div>

        <div className="search-form__section">
          <label className="form-label">Вид послуги</label>
          {isMobile() ? (
            <div className="mobile-select-trigger">
              <span className="mobile-select-text">
                {valueServiceType ? valueServiceType.label : 'Вид послуги'}
              </span>
              <div className="mobile-select-actions">
                <i className="fas fa-chevron-down mobile-dropdown-icon"></i>
              </div>
            </div>
          ) : (
            <Select
              value={valueServiceType}
              options={serviceTypeOptions}
              onChange={onChangeServiceType}
              isSearchable={false}
              placeholder="Вид послуги"
            />
          )}
        </div>
      </div>
      
      <div className="search-form__grid search-form__first-row">
        <div className="search-form__section">
            <label className="form-label">Дата візиту</label>
            <div className="date-input-wrapper">
              <input
                type="date"
                value={visitDate ?? ""}
                onChange={(e) => setVisitDate(e.target.value)}
                min={getTodayDate()}
                max={getMaxDate()}
                className="search-form__date-picker"
                onClick={(e) => e.target.showPicker && e.target.showPicker()}
              />
              {isMobile() && (
                <i className="fas fa-calendar-alt date-icon"></i>
              )}
            </div>
          </div>
        <div className="search-form__section">
          <label className="form-label">Заклад охорони здоров'я</label>
          {isMobile() ? (
            <div 
              className="mobile-select-trigger"
              onClick={() => openMobileModal('institution')}
            >
              <span className="mobile-select-text">
                {valueInstitution ? 
                  `${valueInstitution.name} (${valueInstitution.full_name}${valueInstitution.code ? ' ' + valueInstitution.code : ''})` : 
                  'Оберіть лікарню'
                }
              </span>
              <div className="mobile-select-actions">
                {valueInstitution && (
                  <button 
                    className="mobile-clear-button"
                    onClick={(e) => clearMobileValue('institution', e)}
                    type="button"
                  >
                    <i className="fas fa-times"></i>
                  </button>
                )}
                <i className="fas fa-chevron-down mobile-dropdown-icon"></i>
              </div>
            </div>
          ) : (
            <AsyncPaginate
              key={JSON.stringify([valueRegion, valueCity])}
              value={valueInstitution}
              inputValue={institutionSearchQuery}
              onInputChange={setInstitutionSearchQuery}
              onMenuOpen={onInstitutionMenuOpen}
              onMenuClose={onInstitutionMenuClose}
              loadOptions={loadOptionsInstitution}
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => option.name + ' (' + option.full_name + (option.code != null ? ' ' + option.code : '') + ')'}
              onChange={onChangeInstitution}
              loadingMessage={() => "Завантаження..."}
              noOptionsMessage={() => "Немає варіантів"}
              clearValue
              isSearchable={true}
              isClearable={true}
              placeholder="Оберіть лікарню"
              // isDisabled={!valueCity}
              additional={{
                page: 1,
              }}
            />
          )}
        </div>
      </div>

      <div className="search-form__grid">
        
        <div className="search-form__section">
          <label className="form-label">Посада лікаря (звання)</label>
          {isMobile() ? (
            <div 
              className="mobile-select-trigger"
              onClick={() => openMobileModal('rank')}
            >
              <span className="mobile-select-text">
                {valueRank ? valueRank.name : 'Оберіть посаду'}
              </span>
              <div className="mobile-select-actions">
                {valueRank && (
                  <button 
                    className="mobile-clear-button"
                    onClick={(e) => clearMobileValue('rank', e)}
                    type="button"
                  >
                    <i className="fas fa-times"></i>
                  </button>
                )}
                <i className="fas fa-chevron-down mobile-dropdown-icon"></i>
              </div>
            </div>
          ) : (
            <AsyncPaginate
              key={JSON.stringify([valueRegion, valueCity, valueInstitution])}
              value={valueRank}
              inputValue={rankSearchQuery}
              onInputChange={setRankSearchQuery}
              onMenuOpen={onRankMenuOpen}
              onMenuClose={onRankMenuClose}
              loadOptions={loadOptionsRanks}
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => option.name}
              onChange={onChangeRank}
              loadingMessage={() => "Завантаження..."}
              noOptionsMessage={() => "Немає варіантів"}
              isSearchable={true}
              isClearable={true}
              placeholder="Оберіть посаду"
              additional={{
                page: 1,
              }}
            />
          )}
        </div>
        <div className="search-form__section">
          <label className="form-label">Спеціальність лікаря</label>
          {isMobile() ? (
            <div 
              className="mobile-select-trigger"
              onClick={() => openMobileModal('specialization')}
            >
              <span className="mobile-select-text">
                {valueSpecialization ? valueSpecialization.name : 'Оберіть спеціалізацію'}
              </span>
              <div className="mobile-select-actions">
                {valueSpecialization && (
                  <button 
                    className="mobile-clear-button"
                    onClick={(e) => clearMobileValue('specialization', e)}
                    type="button"
                  >
                    <i className="fas fa-times"></i>
                  </button>
                )}
                <i className="fas fa-chevron-down mobile-dropdown-icon"></i>
              </div>
            </div>
          ) : (
            <AsyncPaginate
              key={JSON.stringify([valueRegion, valueCity, valueInstitution, valueRank])}
              value={valueSpecialization}
              inputValue={specializationSearchQuery}
              onInputChange={setSpecializationSearchQuery}
              onMenuOpen={onSpecializationMenuOpen}
              onMenuClose={onSpecializationMenuClose}
              loadOptions={loadOptionsSpecializations}
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => option.name}
              onChange={onChangeSpecialization}
              loadingMessage={() => "Завантаження..."}
              noOptionsMessage={() => "Немає варіантів"}
              isSearchable={true}
              isClearable={true}
              placeholder="Оберіть спеціалізацію"
              additional={{
                page: 1,
              }}
            />
          )}
        </div>

        <div className="search-form__section">
          <label className="form-label">Лікар</label>
          {isMobile() ? (
            <div 
              className="mobile-select-trigger"
              onClick={() => openMobileModal('doctor')}
            >
              <span className="mobile-select-text">
                {valueDoctor ? valueDoctor.full_name : 'Оберіть лікаря'}
              </span>
              <div className="mobile-select-actions">
                {valueDoctor && (
                  <button 
                    className="mobile-clear-button"
                    onClick={(e) => clearMobileValue('doctor', e)}
                    type="button"
                  >
                    <i className="fas fa-times"></i>
                  </button>
                )}
                <i className="fas fa-chevron-down mobile-dropdown-icon"></i>
              </div>
            </div>
          ) : (
            <AsyncPaginate
              key={JSON.stringify([valueRegion, valueCity, valueInstitution, valueRank, valueSpecialization])}
              value={valueDoctor}
              inputValue={doctorSearchQuery}
              onInputChange={setDoctorSearchQuery}
              onMenuOpen={onDoctorMenuOpen}
              onMenuClose={onDoctorMenuClose}
              loadOptions={loadOptionsDoctors}
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => option.full_name}
              onChange={onChangeDoctor}
              loadingMessage={() => "Завантаження..."}
              noOptionsMessage={() => "Немає варіантів"}
              isSearchable={true}
              isClearable={true}
              placeholder="Оберіть лікаря"
              additional={{
                page: 1,
              }}
            />
          )}
        </div>
      </div>

      {/* Medical Service and Search button on the same row */}
      <div className="search-form__grid search-form__last-row">
        <div className="search-form__section medical-service-section tooltip-bclock">
          <label className="form-label">
            Медична послуга, яка Вас цікавить <span className="required-asterisk">*</span>
            {showTooltip && (
              <div className="tooltip-message">
                Обов'язково оберіть послугу яка вас цікавить
              </div>
            )}
          </label>
          {isMobile() ? (
            <div 
              className="mobile-select-trigger"
              onClick={() => openMobileModal('medicalService')}
            >
              <span className="mobile-select-text">
                {valueMedicalService ? valueMedicalService.title : 'Введіть назву послуги'}
              </span>
              <div className="mobile-select-actions">
                {valueMedicalService && (
                  <button 
                    className="mobile-clear-button"
                    onClick={(e) => clearMobileValue('medicalService', e)}
                    type="button"
                  >
                    <i className="fas fa-times"></i>
                  </button>
                )}
                <i className="fas fa-chevron-down mobile-dropdown-icon"></i>
              </div>
            </div>
          ) : (
            <AsyncPaginate
              key={JSON.stringify([valueRegion, valueCity, valueInstitution, valueRank, valueSpecialization, valueDoctor])}
              value={valueMedicalService}
              inputValue={medicalServiceSearchQuery}
              onInputChange={setMedicalServiceSearchQuery}
              onMenuOpen={onMedicalServiceMenuOpen}
              onMenuClose={onMedicalServiceMenuClose}
              loadOptions={loadOptionsMedicalServices}
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => option.title}
              onChange={onChangeMedicalService}
              loadingMessage={() => "Завантаження..."}
              noOptionsMessage={() => "Немає варіантів"}
              isSearchable={true}
              isClearable={true}
              placeholder="Введіть назву послуги"
              className={showTooltip ? "validation-error" : ""}
              additional={{
                page: 1,
              }}
            />
          )}
        </div>
        
        <div className="search-form__section button-section justify-content-center">
          <button 
            className="search-form__submit btn btn-primary buy"
            onClick={handleSearch}
          >
            Пошук
          </button>
        </div>
      </div>

      {/* Mobile Modal */}
      {showMobileModal && (
        <div className="mobile-select-modal">
          <div className="mobile-select-modal-content">
            <div className="mobile-select-header">
              <h3>
                {showMobileModal === 'region' && 'Оберіть регіон'}
                {showMobileModal === 'city' && 'Оберіть місто'}
                {showMobileModal === 'institution' && 'Оберіть лікарню'}
                {showMobileModal === 'specialization' && 'Оберіть спеціалізацію'}
                {showMobileModal === 'rank' && 'Оберіть посаду'}
                {showMobileModal === 'doctor' && 'Оберіть лікаря'}
                {showMobileModal === 'medicalService' && 'Оберіть послугу'}
              </h3>
              <button className="mobile-select-close" onClick={closeMobileModal}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="mobile-select-search">
              <input
                type="text"
                placeholder="Пошук..."
                value={mobileSearchQuery}
                onChange={(e) => handleMobileSearch(e.target.value)}
                className="mobile-search-input"
                autoFocus
              />
            </div>
            <div className="mobile-select-list">
              {mobileLoading && mobileOptions.length === 0 ? (
                <div className="mobile-select-loading">
                  <i className="fas fa-spinner fa-spin"></i>
                  <span>Завантаження...</span>
                </div>
              ) : mobileOptions.length > 0 ? (
                <>
                  {mobileOptions.map((option) => (
                    <div
                      key={option.id}
                      className="mobile-select-option"
                      onClick={() => selectMobileOption(option)}
                    >
                      {showMobileModal === 'institution' ? 
                        `${option.name} (${option.full_name}${option.code ? ' ' + option.code : ''})` :
                        showMobileModal === 'doctor' ? option.full_name :
                        showMobileModal === 'medicalService' ? option.title : option.name
                      }
                    </div>
                  ))}
                  {mobileHasMore && (
                    <div className="mobile-select-load-more">
                      <button onClick={loadMoreMobileOptions} disabled={mobileLoading}>
                        {mobileLoading ? (
                          <>
                            <i className="fas fa-spinner fa-spin"></i>
                            <span>Завантаження...</span>
                          </>
                        ) : (
                          'Завантажити ще'
                        )}
                      </button>
                    </div>
                  )}
                </>
              ) : (
                <div className="mobile-select-empty">
                  Немає варіантів
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      <style>{`
        .search-form {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          margin-bottom: 1rem;
        }
        .search-form__grid {
          display: grid;
          gap: 1rem;
        }
        @media (min-width: 768px) {
          .search-form__grid {
            grid-template-columns: repeat(3, 1fr);
          }
          
          .search-form__last-row {
            grid-template-columns: 1fr auto;
          }
          .search-form__first-row {
            grid-template-columns: auto 1fr;
          }
          .medical-service-section {
            flex: 1;
          }
          
          .button-section {
            display: flex;
            align-items: flex-end;
            padding-bottom: 2px;
          }
        }
        .search-form__section {
          display: flex;
          flex-direction: column;
        }
        .search-form__section.button-section {
          flex-direction: row;
        }
        .form-label {
          font-weight: 500;
          color: #333;
        }
        .search-form__bottom {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }
        @media (min-width: 992px) {
          .search-form__bottom {
            flex-direction: row;
            align-items: flex-start;
            justify-content: space-between;
            gap: 2rem;
          }
          .search-form__filters-wrapper {
            flex: 1;
          }
        }
        .search-form__filters-wrapper {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }
        .search-form__filters {
          display: flex;
          flex-wrap: wrap;
          gap: 1rem;
        }
        .search-form__submit {
          align-self: flex-end;
          min-width: 150px;
        }
        .search-form__bottom {
          display: flex;
          align-items: flex-start;
        }
        .search-form__filters {
          flex: 1;
          display: flex;
          align-items: center;
          gap: 1rem;
          flex-wrap: wrap;
        }
        .filters-label {
          font-weight: 500;
          color: #333;
          margin-right: 1rem;
        }
        .checkbox-label {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          cursor: pointer;
        }
        .search-form__date-picker {
          width: 100%;
          padding: 0.5rem;
          border: 1px solid #ccc;
          border-radius: 4px;
          font-family: inherit;
          font-size: inherit;
        }
        .search-form__submit {
          min-width: 150px;
        }
        label {
          margin-bottom: 0.1rem;
        }
        .search-form__date-picker {
          height: 38px;
        }
        .required-asterisk {
          color: #e74c3c;
          font-weight: bold;
          margin-left: 3px;
        }
        .tooltip-bclock {
          position: relative;
        }
        .tooltip-message {
          position: absolute;
          background-color: #e74c3c;
          color: white;
          padding: 5px 10px;
          border-radius: 4px;
          font-size: 12px;
          font-weight: normal;
          z-index: 100;
          left: 0;
          top: 60px;
          margin-top: 5px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
          max-width: 250px;
          animation: fadeIn 0.3s ease-in-out;
        }
        
        .tooltip-message:after {
          content: '';
          position: absolute;
          top: -5px;
          left: 10px;
          border-width: 0 5px 5px;
          border-style: solid;
          border-color: transparent transparent #e74c3c transparent;
        }
        
        .validation-error .css-1s2u09g-control {
          border-color: #e74c3c;
          box-shadow: 0 0 0 1px #e74c3c;
        }
        
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        /* Mobile specific styles */
        .mobile .search-form {
          gap: 0.5rem;
          padding: 0 0.5rem;
          width: 100%;
          max-width: 100vw;
          overflow-x: hidden;
        }
        
        .mobile .search-form__section {
          gap: 0.1rem;
          min-width: 0;
          width: 100%;
        }
        
        .mobile .form-label {
          font-size: 1rem;
          font-weight: 600;
          color: #333;
        }
        
        .mobile .search-form__grid {
          gap: 0.3rem;
          width: 100%;
          min-width: 0;
        }
        
        .mobile .search-form__submit {
          align-self: stretch;
          padding: 0.7rem;
          font-size: 1.1rem;
          border-radius: 12px;
          margin-top: 0rem;
        }
        
        .mobile * {
          box-sizing: border-box;
        }
        
        .mobile .search-form,
        .mobile .search-form * {
          max-width: 100%;
          word-wrap: break-word;
        }
        
        .date-input-wrapper {
          position: relative;
          display: flex;
          align-items: center;
        }
        
        .date-icon {
          position: absolute;
          right: 1rem;
          color: #666;
          font-size: 1.1rem;
          pointer-events: none;
          z-index: 1;
        }
        
        .search-form__date-picker {
          width: 100%;
          padding: 0 0.75rem;
          border: 1px solid #ccc;
          border-radius: 5px;
          font-family: inherit;
          font-size: 1rem;
          background: white;
          color: #333;
          height: auto;
          min-height: 38px;
          -webkit-appearance: none;
          -moz-appearance: textfield;
          appearance: none;
          cursor: pointer;
        }
        
        .search-form__date-picker:focus {
          outline: none;
          border-color: #1c5caa;
          box-shadow: 0 0 0 3px rgba(28, 92, 170, 0.1);
        }
        
        .mobile .search-form__date-picker {
          padding: 0.5rem;
          font-size: 1.1rem;
          border-radius: 12px;
          min-height: 40px;
          background: white;
          position: relative;
        }
        
        .mobile .search-form__date-picker::-webkit-calendar-picker-indicator {
          background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='%23333' d='M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1H2zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5z'/%3e%3c/svg%3e") no-repeat;
          background-size: 20px;
          width: 20px;
          height: 20px;
          cursor: pointer;
        }

        /* Mobile Select Styles */
        .mobile-select-trigger {
          width: 100%;
          max-width: 100%; /* Prevent overflow */
          padding: 0.5rem;
          border: 1px solid #ccc;
          border-radius: 12px;
          background: white;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          min-height: 40px;
          color: #333;
          font-size: 1.1rem;
          transition: all 0.2s ease;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
          overflow: hidden; /* Prevent content overflow */
          box-sizing: border-box;
        }
        
        .mobile .mobile-select-trigger {
          width: 100%;
          max-width: calc(100vw - 2rem); /* Account for form padding */
          min-width: 0;
        }
        
        .mobile-select-trigger:hover,
        .mobile-select-trigger:active {
          border-color: #1c5caa;
          box-shadow: 0 0 0 3px rgba(28, 92, 170, 0.1);
        }
        
        .mobile-select-text {
          flex: 1;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          min-width: 0; /* Important for flex child ellipsis */
          max-width: calc(100% - 60px); /* Reserve more space for actions */
        }
        
        .mobile .mobile-select-text {
          max-width: calc(100% - 60px);
          min-width: 0;
        }
        
        .mobile-select-actions {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          flex-shrink: 0;
        }
        
        .mobile-clear-button {
          background: none;
          border: none;
          color: #999;
          font-size: 1rem;
          cursor: pointer;
          padding: 0.25rem;
          border-radius: 50%;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
        }
        
        .mobile-clear-button:hover {
          background-color: rgba(0, 0, 0, 0.1);
          color: #666;
        }
        
        .mobile-dropdown-icon {
          color: #666;
          font-size: 1rem;
        }
        
        .mobile-select-modal {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 1010;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          backdrop-filter: blur(3px);
        }
        
        .mobile-select-modal-content {
          background: white;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          animation: slideInUp 0.3s ease-out;
        }
        
        @keyframes slideInUp {
          from {
            transform: translateY(100%);
          }
          to {
            transform: translateY(0);
          }
        }
        
        .mobile-select-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 1.25rem;
          border-bottom: 1px solid #eee;
          background: #f8f9fa;
          position: sticky;
          top: 0;
          z-index: 10;
        }
        
        .mobile-select-header h3 {
          margin: 0;
          font-size: 1.2rem;
          font-weight: 600;
          color: #333;
        }
        
        .mobile-select-close {
          background: none;
          border: none;
          font-size: 1.5rem;
          cursor: pointer;
          color: #1c5caa;
          padding: 0.75rem;
          border-radius: 50%;
          transition: background-color 0.2s;
        }
        
        .mobile-select-close:hover {
          background-color: rgba(28, 92, 170, 0.1);
        }
        
        .mobile-select-search {
          padding: 1.25rem;
          border-bottom: 1px solid #eee;
          background: white;
          position: sticky;
          top: 73px;
          z-index: 9;
        }
        
        .mobile-search-input {
          width: 100%;
          padding: 1rem;
          border: 1px solid #ddd;
          border-radius: 12px;
          font-size: 1.1rem;
          background: #f8f9fa;
          transition: all 0.2s ease;
        }
        
        .mobile-search-input:focus {
          outline: none;
          border-color: #1c5caa;
          background: white;
          box-shadow: 0 0 0 3px rgba(28, 92, 170, 0.1);
        }
        
        .mobile-select-list {
          flex: 1;
          overflow-y: auto;
          padding: 0;
          -webkit-overflow-scrolling: touch;
        }
        
        .mobile-select-option {
          padding: 1.25rem;
          border-bottom: 1px solid #f0f0f0;
          cursor: pointer;
          transition: background-color 0.2s;
          font-size: 1.05rem;
          line-height: 1.4;
        }
        
        .mobile-select-option:last-child {
          border-bottom: none;
        }
        
        .mobile-select-option:hover {
          background-color: #f8f9fa;
        }
        
        .mobile-select-option:active {
          background-color: #e9ecef;
        }
        
        .mobile-select-loading, .mobile-select-empty {
          padding: 3rem 2rem;
          text-align: center;
          color: #666;
          font-size: 1.1rem;
        }
        
        .mobile-select-loading i {
          margin-right: 0.75rem;
          font-size: 1.25rem;
        }
        
        .mobile-select-load-more {
          padding: 1.5rem;
          text-align: center;
          background: #f8f9fa;
          border-top: 1px solid #eee;
        }
        
        .mobile-select-load-more button {
          background: #1c5caa;
          color: white;
          border: none;
          padding: 1rem 2rem;
          border-radius: 12px;
          cursor: pointer;
          font-size: 1.05rem;
          font-weight: 500;
          transition: all 0.2s ease;
          min-width: 160px;
        }
        
        .mobile-select-load-more button:hover {
          background: #174a91;
        }
        
        .mobile-select-load-more button:disabled {
          background: #6c757d;
          cursor: not-allowed;
        }
        
        .mobile-select-load-more button i {
          margin-right: 0.5rem;
        }
      `}</style>
    </div>
  );
};

const mapStateToProps = ({ user, search, specializations }) => ({ user, search, specializations });

const mapDispatchToProps = { onSearch: search, getSpecializations, searchFocusedToggle };

const SearchFormContainer = connect(mapStateToProps, mapDispatchToProps)(SearchForm);

export default SearchFormContainer;
